module.exports = __webpack_public_path__ + "img/bg-video-4.652ed027.png";